import React, { useCallback, useEffect, useMemo, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../styles/formularios.css';
import '../styles/styles.css';
import Swal from 'sweetalert2';
import logoInstituto from '../components/images/logo.png';
import logoSEP from '../components/images/SEP_Logo_2019.svg.png.jpg';
import { useLocation, useNavigate } from 'react-router-dom';
import { resolveApiBaseList } from '../utils/apiBase';

const ModificarDocentes = () => {
  
    const navigate = useNavigate();
    const location = useLocation();
    const handleSalir = () => {
      const rol = resolveRolBase(location.pathname);
      if (rol) {
        navigate(`/${rol}/inicio`, { replace: true });
      } else {
        // Fallback por si no se detecta rol ni en path ni en localStorage:
        navigate('/inicio', { replace: true });
      }
    };

  const [mostrarBusqueda, setMostrarBusqueda] = useState(false);
  const [mostrarFormulario, setMostrarFormulario] = useState(false);

  const [nombres, setNombres] = useState([]);
  const [nombreSel, setNombreSel] = useState('');
  const [loadingDocente, setLoadingDocente] = useState(false);
  const [guardando, setGuardando] = useState(false);

  const apiBases = useMemo(() => resolveApiBaseList().map((base) => `${base}/docentes`), []);

  const fetchJsonWithFallback = useCallback(async (suffix, options = {}) => {
    let lastError = null;
    for (const base of apiBases) {
      const url = `${base}${suffix}`;
      try {
        const response = await fetch(url, options);
        const text = await response.text();

        if (!response.ok) {
          let message = text || `Error ${response.status}`;
          try {
            const parsed = text ? JSON.parse(text) : null;
            if (parsed && typeof parsed === 'object') {
              message = parsed.message || parsed.error || message;
            }
          } catch (parseErr) {
            // Ignorar parseos fallidos, mantener texto original
          }
          const error = new Error(message);
          error.status = response.status;
          lastError = error;
          console.warn(`⚠️ Falló la petición a ${url}:`, error);
          continue;
        }

        const contentType = response.headers.get('content-type') || '';
        const trimmed = text.trim();
        if (contentType.includes('application/json') || trimmed.startsWith('{') || trimmed.startsWith('[')) {
          return trimmed ? JSON.parse(trimmed) : {};
        }

        lastError = new Error(`Respuesta inválida desde ${url}`);
        console.warn(`⚠️ Contenido no JSON desde ${url} (content-type: ${contentType || 'desconocido'})`);
      } catch (error) {
        lastError = error;
        console.warn(`⚠️ Error de red al solicitar ${url}:`, error);
      }
    }

    throw lastError || new Error('No se pudo contactar al servidor.');
  }, [apiBases]);

  const postWithFallback = useCallback(async (suffix, payload) => {
    let lastError = null;
    for (const base of apiBases) {
      const url = `${base}${suffix}`;
      try {
        const response = await fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });
        const text = await response.text();

        if (!response.ok) {
          let message = text || `Error ${response.status}`;
          try {
            const parsed = text ? JSON.parse(text) : null;
            if (parsed && typeof parsed === 'object') {
              message = parsed.message || parsed.error || message;
            }
          } catch (parseErr) {
            // mantener mensaje original
          }
          const error = new Error(message);
          error.status = response.status;
          lastError = error;
          console.warn(`⚠️ Falló el POST a ${url}:`, error);
          continue;
        }

        const trimmed = text.trim();
        if (trimmed && trimmed.startsWith('<')) {
          const error = new Error(`Respuesta inválida desde ${url}`);
          lastError = error;
          console.warn(`⚠️ Contenido no válido desde ${url}`);
          continue;
        }

        try {
          if (trimmed && (trimmed.startsWith('{') || trimmed.startsWith('['))) {
            const parsed = JSON.parse(trimmed);
            const message = parsed?.message || parsed?.msg || parsed?.resultado || trimmed;
            return { text: message, raw: parsed, url };
          }
        } catch (parseErr) {
          console.warn(`⚠️ No se pudo parsear respuesta JSON desde ${url}:`, parseErr);
        }

        return { text: trimmed, url };
      } catch (error) {
        lastError = error;
        console.warn(`⚠️ Error de red al hacer POST ${url}:`, error);
      }
    }

    throw lastError || new Error('No se pudo contactar al servidor.');
  }, [apiBases]);

  const [form, setForm] = useState({
    IdDocente: '',
    IdUsuario: '',
    Nombre: '',
    ApellidoPaterno: '',
    ApellidoMaterno: '',
    Telefono: '',
    Puesto: '',
    Correo: '',
    Sexo: '',
    TipoSangre: ''
  });

  const handleMostrarBusqueda = () => {
    setMostrarBusqueda(true);
    setMostrarFormulario(false);
  };

  const cargarNombres = useCallback(async () => {
    try {
      const data = await fetchJsonWithFallback('/nombres');
      setNombres(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error('❌ Error al cargar nombres:', err);
      Swal.fire('Error', err.message || 'No se pudieron cargar los nombres de docentes', 'error');
    }
  }, [fetchJsonWithFallback]);

  useEffect(() => {
    if (mostrarBusqueda) cargarNombres();
  }, [cargarNombres, mostrarBusqueda]);

  const handleSeleccionDocente = async (e) => {
    const nombreCompleto = e.target.value;
    setNombreSel(nombreCompleto);
    if (!nombreCompleto) return;

    setLoadingDocente(true);
    try {
      const d = await fetchJsonWithFallback(`/por-nombre/${encodeURIComponent(nombreCompleto)}`);

      if (!d) {
        Swal.fire('Aviso', 'No se encontró el docente seleccionado', 'warning');
        setMostrarFormulario(false);
        return;
      }

      setForm({
        IdDocente: d.IdDocente ?? '',
        IdUsuario: d.IdUsuario ?? '',
        Nombre: d.Nombre ?? '',
        ApellidoPaterno: d.ApellidoPaterno ?? '',
        ApellidoMaterno: d.ApellidoMaterno ?? '',
        Telefono: (d.Telefono ?? '').toString().replace(/\D/g, '').slice(0, 10),
        Puesto: d.Puesto ?? '',
        Correo: d.Correo ?? '',
        Sexo: d.Sexo ?? '',
        TipoSangre: d.TipoSangre ?? ''
      });

      setMostrarFormulario(true);
    } catch (err) {
      console.error('❌ Error al obtener docente:', err);
      Swal.fire('Error', err.message || 'No se pudo obtener la información del docente', 'error');
      setMostrarFormulario(false);
    } finally {
      setLoadingDocente(false);
    }
  };

  const handleTelefonoChange = useCallback((value) => {
    const soloDigitos = value.replace(/\D/g, '').slice(0, 10);
    setForm((prev) => ({ ...prev, Telefono: soloDigitos }));
  }, []);

  const onChange = (e) => {
    const { id, value } = e.target;
    if (id === 'telefono') {
      handleTelefonoChange(value);
      return;
    }
    if (id === 'correo') setForm((p) => ({ ...p, Correo: value }));
  };

  const guardarCambios = async () => {
    if (!form.Nombre || !form.ApellidoPaterno || !form.ApellidoMaterno) {
      Swal.fire('Faltan datos', 'Nombre y apellidos son obligatorios.', 'warning');
      return;
    }
    if (!form.Correo) {
      Swal.fire('Faltan datos', 'Ingresa el correo.', 'warning');
      return;
    }
    if (!form.Telefono) {
      Swal.fire('Faltan datos', 'Ingresa el teléfono.', 'warning');
      return;
    }

    if (!/^\d{10}$/.test(form.Telefono)) {
      Swal.fire('Teléfono inválido', 'El teléfono debe contener exactamente 10 dígitos numéricos.', 'warning');
      return;
    }

    setGuardando(true);
    try {
      const { text } = await postWithFallback('/modificar', {
        nombre: form.Nombre,
        apellidoPaterno: form.ApellidoPaterno,
        apellidoMaterno: form.ApellidoMaterno,
        correo: form.Correo,
        telefono: form.Telefono
      });

      Swal.fire({
        icon: 'success',
        title: 'Modificado',
        text: text || 'Docente modificado correctamente',
        timer: 2000,
        showConfirmButton: false
      });
    } catch (err) {
      console.error('❌ Error al modificar docente:', err);
      Swal.fire('Error', err.message || 'No se pudo modificar el docente', 'error');
    } finally {
      setGuardando(false);
    }
  };

  return (
    <div className="container py-4 px-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <img src={logoInstituto} alt="Logo Instituto" className="logo" />
        <div className="text-center flex-grow-1">
          <h4 className="mb-0">Instituto Silviano Carrillo</h4>
          <small className="text-muted fs-5">Modificar Docentes</small>
        </div>
        <img src={logoSEP} alt="Logo SEP" className="logo" />
      </div>

      <div className="mb-3 d-flex justify-content-center">
        <button className="btn btn-outline-primary" onClick={handleMostrarBusqueda}>
          Modificar por Nombre
        </button>
      </div>

      {mostrarBusqueda && (
        <div className="mb-4">
          <label htmlFor="selectNombre" className="form-label">Selecciona el docente:</label>
          <select
            id="selectNombre"
            className="form-select"
            value={nombreSel}
            onChange={handleSeleccionDocente}
          >
            <option disabled value="">Seleccionar...</option>
            {nombres.map((n, i) => (
              <option key={i} value={n.NombreCompleto}>
                {n.NombreCompleto}
              </option>
            ))}
          </select>
        </div>
      )}

      {mostrarFormulario && (
        <form className="row g-3" id="formDocente" onSubmit={(e)=>e.preventDefault()}>
          <div className="col-md-3">
            <label htmlFor="IdDocente" className="form-label">ID Docente</label>
            <input type="text" id="IdDocente" className="form-control" value={form.IdDocente} readOnly disabled />
          </div>
          <div className="col-md-3">
            <label htmlFor="IdUsuario" className="form-label">Tipo de Usuario</label>
            <input type="text" id="IdUsuario" className="form-control" value={form.IdUsuario} readOnly disabled />
          </div>
          <div className="col-md-3">
            <label htmlFor="Nombre" className="form-label">Nombre</label>
            <input type="text" id="Nombre" className="form-control" value={form.Nombre} readOnly disabled />
          </div>
          <div className="col-md-3">
            <label htmlFor="ApellidoPaterno" className="form-label">Apellido Paterno</label>
            <input type="text" id="ApellidoPaterno" className="form-control" value={form.ApellidoPaterno} readOnly disabled />
          </div>
          <div className="col-md-3">
            <label htmlFor="ApellidoMaterno" className="form-label">Apellido Materno</label>
            <input type="text" id="ApellidoMaterno" className="form-control" value={form.ApellidoMaterno} readOnly disabled />
          </div>

          <div className="col-md-3">
            <label htmlFor="telefono" className="form-label">Teléfono</label>
            <input type="text" id="telefono" className="form-control" value={form.Telefono} onChange={onChange} />
          </div>

          <div className="col-md-3">
            <label htmlFor="Puesto" className="form-label">Puesto</label>
            <input type="text" id="Puesto" className="form-control" value={form.Puesto} readOnly disabled />
          </div>

          <div className="col-md-3">
            <label htmlFor="correo" className="form-label">Correo</label>
            <input type="email" id="correo" className="form-control" value={form.Correo} onChange={onChange} />
          </div>

          <div className="col-md-3">
            <label htmlFor="Sexo" className="form-label">Sexo</label>
            <select id="Sexo" className="form-select" value={form.Sexo} disabled readOnly>
              <option value="M">Masculino</option>
              <option value="F">Femenino</option>
              <option value="O">Otro</option>
            </select>
            
          </div>

          <div className="col-md-3">
            <label htmlFor="TipoSangre" className="form-label">Tipo de Sangre</label>
            <input type="text" id="TipoSangre" className="form-control" value={form.TipoSangre} readOnly disabled />
          </div>

          <div className="d-flex justify-content-center gap-3 mt-4">
            <button
              type="button"
              className="btn btn-warning px-4"
              onClick={guardarCambios}
              disabled={guardando || loadingDocente}
            >
              {guardando ? 'Guardando...' : 'Modificar'}
            </button>
            <button type="button" className="btn btn-danger px-4" onClick={handleSalir}>
             Salir
            </button>
          </div>
        </form>
      )}

      {loadingDocente && (
        <div className="mt-3 text-center text-muted">Cargando datos del docente…</div>
      )}
    </div>
  );
};
/* ----------------- Helper para detectar el rol ----------------- */
function resolveRolBase(pathname) {
  // 1) Intenta desde la URL actual
  const roles = ['directora', 'coordinadora', 'docente', 'alumno'];
  const seg = pathname.split('/').filter(Boolean)[0];
  if (roles.includes(seg)) return seg;

  // 2) Respaldo desde localStorage.role (números mapeados a slugs)
  const roleId = Number(localStorage.getItem('role'));
  const map = { 1: 'directora', 2: 'coordinadora', 3: 'docente', 4: 'alumno' };
  return map[roleId] || null;
}

export default ModificarDocentes;
